import { SearchResultItem } from '../../types';
import { getImageUrl, getTitle, getImageSubtext } from '../../utils';
import { ResultImage } from './result-image';
import { ResultContent } from './result-content';
import { type LocaleCode } from '@ifixit/i18n';
import { Doctype } from '../../types/indices';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';
import aa from 'search-insights';

interface SearchResultCardProps {
   hit: SearchResultItem;
   currency: string;
   localeCode: LocaleCode;
   storeCode: string;
   index: number;
}

/**
 * Main component to display a search result card
 */
export function SearchResultCard({
   hit,
   currency,
   localeCode,
   storeCode,
   index,
}: SearchResultCardProps) {
   const url = hit.url || hit.permalink || '';
   const imageUrl = getImageUrl(hit);
   const imageSubtext = getImageSubtext(hit);
   const doctype = hit.doctype as Doctype;
   const title = getTitle(hit);

   return (
      <a
         href={url}
         onClick={() => {
            trackAnalyticsCustomEvent({
               eventCategory: 'Instant Search',
               eventAction: `Click Result - ${doctype}`,
               eventName: url,
            });
            void aa('clickedObjectIDsAfterSearch', {
               eventName: 'Hit Clicked',
               index: hit._index,
               objectIDs: [hit.objectID],
               queryID: hit._queryID,
               positions: [index + 1],
            });
         }}
         className="flex items-center gap-2 sm:gap-3 p-1 sm:py-2 sm:px-4 w-full !no-underline !hover:no-underline"
      >
         <div className="flex flex-col items-start gap-2.5 w-16">
            <ResultImage
               imageUrl={imageUrl}
               title={title}
               doctype={doctype}
               imageSubtext={imageSubtext}
            />
         </div>
         <div className="flex items-center gap-3 grow">
            <div className="flex flex-col justify-center items-start gap-1.5 grow">
               <ResultContent
                  hit={hit}
                  currency={currency}
                  localeCode={localeCode}
                  storeCode={storeCode}
               />
            </div>
         </div>
      </a>
   );
}
